
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watchEffect, watch, onUnmounted } from 'vue'
import { RightOutlined } from '@ant-design/icons-vue'
import { askApi } from '@/api/index'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import stock from '@/utils/stock'
import { message, Modal } from 'ant-design-vue'
import store from '@/store/index'
import { useStore, mapState, mapMutations, mapActions } from 'vuex'
import Askcollapse from '@/components/asktheSecretary/askcollapse.vue'
import globalsets from '@/utils/globalsets'
import Nodata from '@/components/page/nodata.vue'
import ws from '../../websocket/index'
export default defineComponent({
  components: {
    Askcollapse,
    RightOutlined,
    Nodata
  },
  props: {
    token: {
      type: String,
      default: () => {
        return ''
      }
    },
    navObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    keywords: {
      type: Array,
      default: () => {
        return []
      }
    },
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    }
  },
  setup(props: any) {
    const store = useStore()
    const route = useRoute()
    const pageData: any = reactive({
      cardList: [],
      // 已选入自选股的股票
      inOptionalData: [],
      optionalShares: [],
      optionalSharesGroupData: [],
      treeData: store.state.OptionalList.filter((item: any) => item.groupType !== 0),
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      checkedKeys: [],
      selectedKeys: [],
      visibleInst: {},
      optionalSharesProps: {
        title: 'groupName',
        key: 'id',
        value: 'id'
      },
      PageID: -1,
      pageSize: 10,
      loading: false,
      allloaded: false, // 加载完成标志
      titleInfo: {
        Inst: route.query.code,
        Exch: route.query.market,
        Name: '',
        ID: route.query.id
      },
      modalVisible: false,
      updateIndex: 0,
      websock: null,
      token: ''
    })
    const theme = route.query.theme || 'light'

    gettoken()
    async function gettoken() {
      pageData.token = await globalsets.getToken()
      onSearch(false)
    }
    let lefttimer: any = null
    // 除去自选股 的其他自选分组
    pageData.optionalShares = computed(() => {
      const data = store.state.OptionalList
      const result = data.filter((item: any) => {
        return item.groupType !== 0
      })
      return result
    })
    pageData.inOptionalData = computed(() => {
      const data = (store.state.OptionalList || []).filter((item: any) => {
        return item.groupType === 0
      })
      // 自选股
      let obj: any = {}
      if (data.length) obj = data[0]
      const result = (obj.stockList || []).map((item: any) => item.securityNo)
      return result
    })
    pageData.optionalSharesGroupData = computed(() => {
      if (pageData.optionalShares.length) {
        const data = (pageData.optionalShares || []).map((item: any) => item.stockList).flat()
        const securityNos = data.map((item: any) => item.securityNo)
        return securityNos
      } else {
        return []
      }
    })
    async function onSearch(scroll: boolean) {
      pageData.loading = true
      const data: any = {}
      data.data = {
        Exch: pageData.titleInfo.Exch,
        Inst: pageData.titleInfo.Inst,
        ID: pageData.titleInfo.ID,
        Limit: -1
      }
      data.headers = {
        token: pageData.token
      }
      let cardlist = await getData(data, scroll)
      const ids = cardlist.map((item: any) => item.ID)
      if (ids.indexOf(pageData.titleInfo.ID) < 0) {
        data.data = {
          Exch: pageData.titleInfo.Exch,
          Inst: pageData.titleInfo.Inst,
          ID: cardlist[0].ID,
          Limit: 1
        }
        const preData = await getData(data, false)
        cardlist = preData
      }
      pageData.cardList = cardlist
      pageData.loading = false
    }
    function getData(data: any, scroll: boolean) {
      return askApi.getInfoSecretaryIdRank(data).then((res: any) => {
        if ((res.Data || []).length < 20) pageData.allloaded = true
        if ((res.Data || []).length) {
          res.Data.forEach((item: any) => {
            item.ATime = globalsets.formatTime(item.ATime)
            item.QTime = globalsets.formatTime(item.QTime)
          })
          return res.Data
        } else {
          if (!scroll) pageData.cardList = []
        }
      })
    }
    function handleOptionalShares(checkedkeys: any, check: any, row: any, i: number) {
      const e = { id: check.node.eventKey }
      if (check.checked) {
        // 添加
        addOptionalShares(e, row, i)
      } else {
        removeOptionalShares(e, row, e.id, i)
      }
    }
    async function addOptionalShares(e: any, row: any, i: number) {
      let g = e
      if (!e && pageData.visibleInst[row.Inst + '' + i]) return
      if (!e) {
        // 如果当前股的下拉框是打开的，则什么操作也不做
        const data = store.state.OptionalList.filter((item: any) => item.groupType === 0)
        g = data[0]
      }
      const res = await stock.addStock(g, row, store.state.loginInfo)
      if (res === 1) {
        store.commit('setChangeOptionalTime', Date.now())
        if (!e) {
          message.success('已成功添加到自选股')
        }
      }
    }
    async function removeOptionalShares(e: any, row: any, id: string, i: number) {
      let g = e
      if (!e && pageData.visibleInst[row.Inst + '' + i]) return
      if (!e) {
        // 如果当前股的下拉框是打开的，则什么操作也不做
        g = store.state.OptionalList.filter((item: any) => item.groupType === 0)
      }
      const ids: any = []
      if (id) {
        ids.push(id)
      } else {
        ids.push(g[0].id)
      }
      const res = await stock.removeStock(ids, row, store.state.loginInfo)
      if (res === 1) {
        store.commit('setChangeOptionalTime', Date.now())
        if (!e) {
          message.success('已从自选股中删除')
        }
      }
    }
    function visibleChange(visible: any, row: any, i: number) {
      pageData.visibleInst[row.Inst + '' + i] = visible
      if (visible) {
        // 所有 【除去自选股】的 自选分组
        const inst = row.Inst
        const data = store.state.OptionalList.filter((item: any) => {
          return item.groupType !== 0
        })
        const ids: number[] = []
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          if (item.stockList.length) {
            const arr = (item.stockList || []).map((o: any) => o.securityNo)
            if (arr.indexOf(inst) > -1) {
              ids.push(item.id)
            }
          }
        }
        pageData.checkedKeys = ids
        // setscroll()
      } else {
        pageData.visibleInst = {}
        // const lel: any = document.querySelectorAll('.cardwrap')
        // if (!lel) return
        // lel.removeEventListener('scroll', setscroll)
      }
    }
    function setscroll() {
      nextTick(() => {
        const lel: any = document.querySelectorAll('.cardwrap')
        if (!lel) return
        if (!Object.keys(pageData.visibleInst).length) {
          lel.removeEventListener('scroll', hanldescrollFn)
        } else {
          lel.addEventListener('scroll', hanldescrollFn)
        }
      })
    }
    function hanldescrollFn() {
      const obj: any = pageData.visibleInst
      for (const key in obj) {
        pageData.visibleInst[key] = false
        pageData.tablepopoverkey[key] = Date.now()
      }
      const lel: any = document.querySelectorAll('.cardwrap')
      if (!lel) return
      lel.removeEventListener('scroll', hanldescrollFn)
    }
    function settime() {
      const lel: any = document.querySelector('.cardwrap')
      const lastScrollY = lel.scrollTop
      lel.onscroll = () => {
        const offsetHeight = lel.offsetHeight
        const scrollTop = lel.scrollTop
        const scrollHeight = lel.scrollHeight
        const UpOrDown = scrollTop < lastScrollY ? 'up' : 'down'
        if (UpOrDown === 'down') {
          if (offsetHeight + scrollTop - scrollHeight >= 0 && scrollTop > 0) {
            // 需要执行的代码
            pageData.PageID = 1
            pageData.loading = true
            if (!lefttimer && !pageData.allloaded) {
              lefttimer = setTimeout(function () {
                onSearch(true)
                // getData('')
                lefttimer = null
                pageData.loading = false
              }, 500)
            }
            if (pageData.allloaded) {
              pageData.loading = false
            }
          }
        }
        if (UpOrDown === 'up' && scrollTop < 0) {
          pageData.PageID = -1
          pageData.loading = true
          if (!lefttimer && !pageData.allloaded) {
            lefttimer = setTimeout(function () {
              onSearch(true)
              lefttimer = null
              pageData.loading = false
            }, 500)
          }
          if (pageData.allloaded) {
            pageData.loading = false
          }
        }
      }
    }
    onMounted(() => {
      if(route.query.code&&route.query.market){
        ws.websocket.safeSubscribeDYNA(route.query.code,route.query.market)
        ws.websocket.on('onMessage', msg => {
          const _data = msg.QuoteData
          if (msg.Inst === pageData.titleInfo.Inst) {
            if (msg.QuoteData && (msg.QuoteData.DynaData || [])[0]) {
              pageData.titleInfo.DynaData = (msg.QuoteData.DynaData || [])[0]
            }
            if (msg.QuoteData && (msg.QuoteData.StatisticsData || [])[0]) {
              pageData.titleInfo.StatisticsData = (msg.QuoteData.StatisticsData || [])[0]
            }
            if (_data && _data.StaticData && (_data.StaticData || []).length > 0) {
              pageData.titleInfo.Name = _data.StaticData[0].InstrumentName
            }
            pageData.titleInfo.LastPrice = pageData.titleInfo.DynaData ? pageData.titleInfo.DynaData.LastPrice : 0
            pageData.titleInfo.increase =
              pageData.titleInfo.DynaData && pageData.titleInfo.StatisticsData
                ? ((pageData.titleInfo.DynaData.LastPrice - pageData.titleInfo.StatisticsData.PreClosePrice) / pageData.titleInfo.StatisticsData.PreClosePrice) *
                  100
                : 0
          }
        })

      }
    })
    function gotoDetail() {
      const origin = document.location.origin
      // const url = `gw://funccall?funcname=OnDoCommand;param=问董秘;param0=${pageData.titleInfo.Exch};param1=${pageData.titleInfo.Inst}`
      const url = `gw://funccall?funcname=OnFireCommand;Command=CmdStyle.WDM;param=<params><web_inner_url>${origin}/operationmanual/index.html#/asking?market=${pageData.titleInfo.Exch}&code=${pageData.titleInfo.Inst}</web_inner_url><stock_list><list_code>问董秘</list_code></stock_list></params>`
      window.open(url)
    }
    return {
      ...toRefs(pageData),
      onSearch,
      route,
      handleOptionalShares,
      visibleChange,
      addOptionalShares,
      removeOptionalShares,
      getNumber: globalsets.getNumber,
      getPencent: globalsets.getPencent,
      gotoDetail
    }
  }
})
